export const SEND_ADDITIONAL_DOCS_DATA_DEFAULT = {
	protocol: '',
	protocolCode: '',
	requestCode: '',
	request: '',
	files: [],
	observations: '',
	requestDate: '',
	refundNumber: '',
};
